/**
 * Extracts a user-friendly error message from an RPC error object.
 *
 * @param error - The error object from RPC call
 * @param fallback - Fallback message if no detailed message is available
 * @returns The error message to display to the user
 */
export function getErrorMessage(error: any, fallback: string): string {
  // Try to get the detailed message from the backend
  if (error?.data?.message) {
    return error.data.message
  }

  // Fallback to top-level message
  if (error?.message) {
    return error.message
  }

  // Use provided fallback
  return fallback
}